import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/engagement/inquiries";

export const Route = createFileRoute("/admin/_engagement/inquiries")({
  component: Page,
});
